import { useState } from 'react';
import { db } from '../../firebase/config';
import { collection, query, where, getDocs } from 'firebase/firestore';

// Formateador a DD/MM/YYYY
const formatearFechaVisual = (fechaRaw) => {
    if (!fechaRaw) return '-';
    if (typeof fechaRaw === 'string' && fechaRaw.includes('-')) {
        const parts = fechaRaw.split('T')[0].split('-');
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    if (fechaRaw?.toDate) {
        const d = fechaRaw.toDate();
        return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
    }
    const d = new Date(fechaRaw);
    if (!isNaN(d.getTime())) {
        return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
    }
    return String(fechaRaw);
};

export const useValidarDeudaCliente = () => {
    const [polizasAfectadas, setPolizasAfectadas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [cargado, setCargado] = useState(false);

    // Se ejecuta solo cuando el usuario hace clic en "Ver Pólizas"
    const obtenerPolizasConDeuda = async (clienteId) => {
        if (!clienteId || cargado) return;

        setLoading(true);
        setError(null);

        try {
            const q = query(
                collection(db, 'public/data/clientes', clienteId, 'polizas'),
                where('tieneDeuda', '==', true)
            );

            const snapshot = await getDocs(q);

            if (snapshot.empty) {
                setPolizasAfectadas([]);
            } else {
                const polizas = snapshot.docs.map(doc => {
                    const data = doc.data();
                    const fVencRaw = data.finVigencia || data.fechaVencimiento || null;
                    return {
                        id: doc.id,
                        nPoliza: data.nPoliza || 'S/N',
                        compania: data.compania || 'Sin Compañía',
                        riesgo: data.riesgo || 'General',
                        subriesgo: data.subriesgo || '',
                        motivo: data.motivo || '',
                        finVigencia: formatearFechaVisual(fVencRaw),
                        premio: data.premio || 0,
                        moneda: data.moneda || '$'
                    };
                });
                setPolizasAfectadas(polizas);
            }
            setCargado(true);
        } catch (err) {
            console.error(`Error al consultar pólizas con deuda:`, err);
            setError(err.message || 'Error al obtener pólizas');
        } finally {
            setLoading(false);
        }
    };

    return {
        polizasAfectadas,
        loading,
        error,
        obtenerPolizasConDeuda
    };
};